// extracted by mini-css-extract-plugin
export default {"fileUploadOver":"FileUpload_fileUploadOver__-WFXY","fileUploadStandard":"FileUpload_fileUploadStandard__Dr-sN"};